/* Verdant Lounge — premium cart drawer (self-contained, no theme setting needed) */
(function () {
  var money = function (c) { return '£' + (c / 100).toFixed(2); };
  var root, panel, itemsEl, footEl, busy = false;

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'vlc';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="vlc__overlay" data-close></div>' +
      '<aside class="vlc__panel" role="dialog" aria-modal="true" aria-label="Shopping cart">' +
        '<header class="vlc__head">' +
          '<h2 class="vlc__title">Your cart</h2>' +
          '<button class="vlc__close" type="button" data-close aria-label="Close cart">' +
            '<svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="vlc__items" tabindex="-1"></div>' +
        '<footer class="vlc__foot"></footer>' +
      '</aside>';
    document.body.appendChild(root);
    panel = root.querySelector('.vlc__panel');
    itemsEl = root.querySelector('.vlc__items');
    footEl = root.querySelector('.vlc__foot');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { close(); return; }
      var btn = e.target.closest('[data-line]');
      if (btn) {
        e.preventDefault();
        change(btn.dataset.line, btn.dataset.qty);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
    });
  }

  function render(cart) {
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="vlc__empty"><p>Your cart is empty.</p>' +
        '<a class="vlc__btn vlc__btn--ghost" href="/collections/all-garden-buildings">Browse garden buildings</a></div>';
      footEl.innerHTML = '';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.name + ': ' + o.value; }).join(' &middot; ');
      return '<div class="vlc__item">' +
        (img ? '<a class="vlc__thumb" href="' + it.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' : '<span class="vlc__thumb"></span>') +
        '<div class="vlc__info">' +
          '<a class="vlc__name" href="' + it.url + '">' + it.product_title + '</a>' +
          (opts ? '<p class="vlc__opts">' + opts + '</p>' : '') +
          '<p class="vlc__price">' + money(it.final_line_price) + '</p>' +
          '<div class="vlc__qty">' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="vlc__rm" type="button" data-line="' + (i + 1) + '" data-qty="0" aria-label="Remove">Remove</button>' +
      '</div>';
    }).join('');

    footEl.innerHTML =
      '<div class="vlc__row"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class="vlc__note">Taxes and delivery calculated at checkout.</p>' +
      '<a class="vlc__btn" href="/checkout">Checkout</a>' +
      '<button class="vlc__btn vlc__btn--ghost" type="button" data-close>Continue shopping</button>';
  }

  function bubble(count) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
        b.innerHTML = '<span aria-hidden="true">' + count + '</span>';
      } else if (b) { b.remove(); }
    });
  }

  function load() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })
      .then(function (c) { render(c); bubble(c.item_count); return c; });
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    panel.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (r) { return r.json(); })
      .then(function (c) { render(c); bubble(c.item_count); })
      .catch(function () {})
      .then(function () { busy = false; panel.classList.remove('is-busy'); });
  }

  function open() {
    build();
    root.removeAttribute('hidden');
    document.body.classList.add('vlc-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    load();
    setTimeout(function () { itemsEl.focus(); }, 60);
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('vlc-open');
    setTimeout(function () { root.setAttribute('hidden', ''); }, 320);
  }

  // open on cart icon / cart links
  document.addEventListener('click', function (e) {
    var t = e.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"]');
    if (!t) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open();
  });

  
})();
